<template>
  <div class="register_container">
    <div class="register_box">
      <h3 class="register-title">注册账号</h3>
      <el-form ref="registerFormRef" :model="addUserForm" :rules="registerFormRules" label-width="0px" class="login_form">
        <!-- 用户账号 -->
        <el-form-item prop="userAccount">
          <el-input v-model="addUserForm.userAccount"
                    prefix-icon="iconfont icon-user"
                    clearable
                    placeholder="请输入账号"></el-input>
        </el-form-item>

        <!-- 密码 -->
        <el-form-item prop="password">
          <el-input v-model="addUserForm.password"
                    prefix-icon="iconfont icon-3702mima"
                    type="password"
                    clearable
                    show-password
                    placeholder="请输入密码"></el-input>
        </el-form-item>

        <!-- 确认密码 -->
        <el-form-item prop="checkPassword">
          <el-input v-model="addUserForm.checkPassword"
                    prefix-icon="iconfont icon-3702mima"
                    type="password"
                    clearable
                    show-password
                    placeholder="请确认密码"></el-input>
        </el-form-item>

        <!-- 邀请账号 -->
        <el-form-item prop="inviteAccount">
          <el-input v-model="addUserForm.inviteAccount"
                    prefix-icon="el-icon-user"
                    clearable
                    placeholder="请输入邀请账号（选填）"></el-input>
        </el-form-item>

        <!-- 邮箱 -->
        <el-form-item prop="userEmail">
          <el-input v-model="addUserForm.userEmail"
                    prefix-icon="el-icon-message"
                    clearable
                    placeholder="请输入邮箱"></el-input>
        </el-form-item>

        <!-- 验证码 -->
        <el-form-item prop="code">
          <el-input v-model="addUserForm.code"
                    prefix-icon="el-icon-key"
                    clearable
                    placeholder="请输入验证码"
                    class="code-input">
            <el-button
              slot="append"
              @click="sendCode">
              {{ isCodeSending ? countdown + '秒' : '发送验证码' }}
            </el-button>
          </el-input>
        </el-form-item>

        <!-- 按钮区域 -->
        <el-form-item class="btns">
          <el-button type="text" @click="openLogin">返回登录</el-button>
          <el-button type="primary" @click="register" :loading="registerLoading">注册</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- ICP备案号 -->
    <div class="icp-footer">
      <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer">
        粤ICP备2026058420号
      </a>
    </div>
  </div>
</template>

<script>
// 引入 jsencrypt 和 Base64 编码库
import JSEncrypt from 'jsencrypt'
// 需要安装 js-base64 库
import { Base64 } from 'js-base64'

export default {
  data() {
    // 自定义账号验证函数（必填，用于 userAccount）
    const validateAccount = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入账号'))
        return
      }
      if (value.length < 2 || value.length > 18) {
        callback(new Error('账号长度必须为2-18位'))
        return
      }
      if (/^\d+$/.test(value)) {
        callback(new Error('账号不能全是数字'))
        return
      }
      // 允许中文、英文、数字、下划线、@、.
      if (!/^[\u4e00-\u9fa5a-zA-Z0-9_@.]+$/.test(value)) {
        callback(new Error('账号只能包含中文、英文、数字、下划线、@、.'))
        return
      }
      callback()
    }

    // 自定义邀请账号验证函数（选填，有值才校验）
    const validateInviteAccount = (rule, value, callback) => {
      // 选填，为空时直接通过
      if (!value) {
        callback()
        return
      }
      // 有值才校验
      if (value.length < 2 || value.length > 18) {
        callback(new Error('邀请账号长度必须为2-18位'))
        return
      }
      if (/^\d+$/.test(value)) {
        callback(new Error('邀请账号不能全是数字'))
        return
      }
      // 允许中文、英文、数字、下划线、@、.
      if (!/^[\u4e00-\u9fa5a-zA-Z0-9_@.]+$/.test(value)) {
        callback(new Error('邀请账号只能包含中文、英文、数字、下划线、@、.'))
        return
      }
      callback()
    }

    // 自定义确认密码校验规则
    const validateCheckPassword = (rule, value, callback) => {
      if (value !== this.addUserForm.password) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }

    return {
      publicKey: null,
      countdown: 60,
      timer: null,
      isCodeSending: false,
      registerLoading: false,
      registerDialogVisible: false,
      addUserForm: {
        userAccount: '',
        password: '',
        checkPassword: '',
        inviteAccount: '',
        userEmail: '',
        code: ''
      },
      registerFormRules: {
        userAccount: [
          { required: true, message: '请输入账号', trigger: 'blur' },
          { validator: validateAccount, trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 15, message: '密码的长度在6~15个字符之间', trigger: 'blur' },
          {
            pattern: /^[A-Za-z0-9!@#$%^&*()_+={}[\]:;"'<>,.?/~`-]+$/,
            message: '密码只能包含英文字母、数字和特殊字符，不允许中文',
            trigger: 'blur'
          }
        ],
        checkPassword: [
          { required: true, message: '请再次输入密码', trigger: 'blur' },
          { validator: validateCheckPassword, trigger: 'blur' }
        ],
        inviteAccount: [
          { validator: validateInviteAccount, trigger: 'blur' }
        ],
        userEmail: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          {
            pattern: /^[a-zA-Z0-9_\-.]+@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,4}$/,
            message: '邮箱号格式不正确：正确格式为 xxx@xxx.xx',
            trigger: 'blur'
          }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          {
            pattern: /^[0-9a-zA-Z]{6,}$/,
            message: '验证码格式不正确，必须是至少6位字母或数字',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  methods: {
    clearInterval() {
      clearInterval(this.timer)
      this.isCodeSending = false
      this.countdown = 60
    },

    async sendCode() {
      if (this.isCodeSending) return

      const validateFieldPromise = (prop) => {
        return new Promise((resolve, reject) => {
          this.$refs.registerFormRef.validateField(prop, (errorMessage) => {
            if (errorMessage) {
              reject(errorMessage)
            } else {
              resolve()
            }
          })
        })
      }

      try {
        await validateFieldPromise('userAccount')
        await validateFieldPromise('password')
        await validateFieldPromise('checkPassword')
        await validateFieldPromise('userEmail')
      } catch (error) {
        this.$message.warning('请先正确填写账号、密码和邮箱')
        return
      }

      if (this.addUserForm.password !== this.addUserForm.checkPassword) {
        this.$message.warning('两次输入的密码不一致')
        return
      }

      const email = this.addUserForm.userEmail && this.addUserForm.userEmail.trim()
      if (!email) {
        this.$message.warning('请输入邮箱')
        return
      }

      this.isCodeSending = true

      try {
        const formData = new FormData()
        formData.append('userEmail', email)
        const { data: result } = await this.$http.post('/user/sendCode', formData)

        if (result.status === 200) {
          this.$message.success('验证码已发送')
          this.countdown = 60
          if (this.timer) {
            clearInterval(this.timer)
          }
          this.timer = setInterval(() => {
            this.countdown--
            if (this.countdown <= 0) {
              this.clearInterval()
            }
          }, 1000)
        } else {
          this.$message.error(result.message)
          this.isCodeSending = false
        }
      } catch (error) {
        this.$message.error('验证码发送失败')
        this.isCodeSending = false
      }
    },

    async register() {
      this.$refs.registerFormRef.validate(async (valid) => {
        if (!valid) return
        await this.fetchPublicKey()
        this.isCodeSending = true
        this.registerLoading = true
        try {
          const encryptedPassword = this.encryptString(this.addUserForm.password)
          const base64EncodedPassword = Base64.encode(encryptedPassword)
          const formData = {
            userAccount: this.addUserForm.userAccount,
            password: base64EncodedPassword,
            inviteAccount: this.addUserForm.inviteAccount || '',
            userEmail: this.addUserForm.userEmail,
            code: this.addUserForm.code
          }
          const { data: result } = await this.$http.post('/user/registerUser', formData)
          if (result.status === 200) {
            this.$message.success(result.message)
            this.$router.push('/login')
          } else {
            this.$message.warning(result.message)
            this.clearInterval()
          }
        } catch (error) {
          this.$message.error('注册失败')
        } finally {
          this.isCodeSending = false
          this.registerLoading = false
        }
      })
    },

    openLogin() {
      this.$router.push('/login')
    },

    async fetchPublicKey() {
      try {
        const { data } = await this.$http.get('/rsa/getPublicKey')
        this.publicKey = data
      } catch (error) {
        console.error('操作失败，请刷新重试:', error)
        this.$message.error('操作失败，请刷新重试')
      }
    },

    encryptString(str) {
      const encrypt = new JSEncrypt()
      encrypt.setPublicKey(this.publicKey)
      return encrypt.encrypt(str)
    }
  }
}
</script>

<style lang="less" scoped>
.register_container {
  height: 100%;
  width: 100%;
  overflow: hidden;
  position: relative;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 25%, #0f3460 50%, #1a1a2e 75%, #16213e 100%);
  background-size: 200% 200%;
  animation: gradientShift 10s ease infinite;
}

.register_container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image:
    radial-gradient(circle at 20% 40%, rgba(64, 158, 255, 0.15) 1px, transparent 1px),
    radial-gradient(circle at 80% 70%, rgba(64, 158, 255, 0.1) 1px, transparent 1px),
    radial-gradient(circle at 40% 80%, rgba(100, 200, 255, 0.08) 1px, transparent 1px),
    radial-gradient(circle at 60% 20%, rgba(64, 158, 255, 0.12) 1px, transparent 1px);
  background-size: 60px 60px, 80px 80px, 100px 100px, 70px 70px;
  pointer-events: none;
  animation: particleFloat 20s linear infinite;
}

@keyframes particleFloat {
  0% {
    background-position: 0 0, 0 0, 0 0, 0 0;
  }
  100% {
    background-position: 100px 100px, 150px 150px, 200px 200px, 80px 80px;
  }
}

.register_box {
  width: 450px;
  height: auto;
  background-color: #fff;
  border-radius: 16px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding: 0 30px 30px 30px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(64, 158, 255, 0.1);
  border: 1px solid rgba(64, 158, 255, 0.3);
  box-sizing: border-box;
}

.register-title {
  text-align: center;
  font-size: 24px;
  font-weight: bold;
  padding: 30px 0 30px 0;
  margin: 0;
  background: linear-gradient(135deg, #409EFF, #66b1ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.login_form {
  width: 100%;
  box-sizing: border-box;
}

.btns {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 0;
}

/* ICP备案号样式 */
.icp-footer {
  position: absolute;
  bottom: 16px;
  left: 0;
  right: 0;
  text-align: center;
}

.icp-footer a {
  color: #909399;
  font-size: 12px;
  text-decoration: none;
  transition: color 0.3s;
}

.icp-footer a:hover {
  color: #409EFF;
  text-decoration: underline;
}
</style>
